(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  class HoverMegaMenu {
    constructor() {
      this.closeTimers = new WeakMap();
      document.querySelectorAll('.header__inline-menu header-menu').forEach((menu) => {
        const details = menu.querySelector('details');
        if (!details) return;

        /* A parent with its own URL ("Shop gifts" > /collections) goes there
           on a click. Hover still opens the panel; a keyboard Enter or Space
           (detail 0) keeps toggling it, so the panel stays reachable. */
        const summary = details.querySelector('summary[data-href]');
        if (summary) {
          summary.addEventListener('click', (event) => {
            if (event.detail === 0) return;
            event.preventDefault();
            window.location.href = summary.dataset.href;
          });
        }

        menu.addEventListener('mouseenter', () => {
          clearTimeout(this.closeTimers.get(menu));
          details.setAttribute('open', '');
        });

        /* Close delay: 300ms, in the 250–500ms range menu guidelines settle
           on, so a slow or slightly off-line move from the link to the
           panel doesn't drop the menu (merchant feedback, 3 October 2026 —
           it was 120ms). Re-entering cancels it (mouseenter above). The gap
           between link and panel is also bridged in CSS (summary::after in
           component-mega-menu-redesign.css), so on a straight path the
           pointer never leaves the menu at all. */
        menu.addEventListener('mouseleave', () => {
          const timer = setTimeout(() => details.removeAttribute('open'), 300);
          this.closeTimers.set(menu, timer);
        });
      });
    }
  }

  document.addEventListener('DOMContentLoaded', () => new HoverMegaMenu());

  /*
   * Three-level mega menu ("Shop gifts" > ranges > flavours), rendered by
   * snippets/header-mega-menu.liquid. Column 1's range links each own a
   * panel; hovering or focusing a range shows its panel and hides the
   * others. The range links stay real links — a click (or a tap at desktop
   * width) navigates to the range page.
   *
   * Until this upgrades, nothing is hidden and every panel sits stacked
   * under its link (component-mega-menu-redesign.css), so the menu works
   * without JS. data-enhanced switches the CSS to the two-column layout.
   *
   * Delegated mouseover/focusin on the host rather than mouseenter on each
   * <li>: once enhanced the <li> is display: contents and has no box of its
   * own, and both events bubble from whatever the pointer or focus lands on.
   */
  class MegaMenuRanges extends HTMLElement {
    connectedCallback() {
      this.ranges = Array.from(this.querySelectorAll('[data-range]'));
      if (this.ranges.length === 0) return;

      this.defaultRange =
        this.ranges.find((range) => range.classList.contains('mega-menu__range--active')) || this.ranges[0];

      this.onActivate = (event) => {
        const range = event.target.closest('[data-range]');
        if (range && this.contains(range)) this.activate(range);
      };
      this.addEventListener('mouseover', this.onActivate);
      this.addEventListener('focusin', this.onActivate);
      // Click too: Safari does not focus a <button> on click, so a no-URL
      // range (a <button>, snippets/header-mega-menu.liquid) would otherwise
      // never activate there on a tap without hover.
      this.addEventListener('click', this.onActivate);

      // Each time the menu closes it reopens on the default range.
      this.details = this.closest('details');
      this.onToggle = () => {
        if (!this.details.open) this.activate(this.defaultRange);
      };
      if (this.details) this.details.addEventListener('toggle', this.onToggle);

      this.activate(this.defaultRange);
      this.setAttribute('data-enhanced', '');
    }

    disconnectedCallback() {
      if (this.details && this.onToggle) this.details.removeEventListener('toggle', this.onToggle);
      if (this.onActivate) {
        this.removeEventListener('mouseover', this.onActivate);
        this.removeEventListener('focusin', this.onActivate);
        this.removeEventListener('click', this.onActivate);
      }
    }

    activate(activeRange) {
      if (activeRange === this.activeRange) return;
      this.activeRange = activeRange;
      this.ranges.forEach((range) => {
        const isActive = range === activeRange;
        range.classList.toggle('mega-menu__range--active', isActive);
        const panel = range.querySelector('[data-range-panel]');
        if (panel) panel.hidden = !isActive;
      });

      // The feature column follows the active range: its own image if it
      // has one (data-range-feature-key), the default image otherwise.
      const inner = this.closest('.mega-menu__inner');
      const features = inner ? Array.from(inner.querySelectorAll('[data-range-feature]')) : [];
      if (features.length) {
        const wanted = activeRange.dataset.rangeFeatureKey || 'default';
        const key = features.some((f) => f.dataset.rangeFeature === wanted) ? wanted : 'default';
        features.forEach((f) => {
          f.hidden = f.dataset.rangeFeature !== key;
        });
      }
    }
  }

  if (!customElements.get('mega-menu-ranges')) customElements.define('mega-menu-ranges', MegaMenuRanges);

  } catch(e) { console.error(e); }
})();
})();
